var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0556 9.5L18.1667 2.38889C18.6111 1.94444 18.6111 1.27778 18.1667 0.833333C17.7222 0.388889 17.0556 0.388889 16.6111 0.833333L9.5 7.94444L2.38889 0.833333C1.94444 0.388889 1.27778 0.388889 0.833333 0.833333C0.388889 1.27778 0.388889 1.94444 0.833333 2.38889L7.94444 9.5L0.833333 16.6111C0.388889 17.0556 0.388889 17.7222 0.833333 18.1667C1.27778 18.6111 1.94444 18.6111 2.38889 18.1667L9.5 11.0556L16.6111 18.1667C17.0556 18.6111 17.7222 18.6111 18.1667 18.1667C18.6111 17.7222 18.6111 17.0556 18.1667 16.6111L11.0556 9.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.323247ce821ceafddb59ef2799b83d6b.svg";
export { ForwardRef as ReactComponent };